import React from "react";
import "../Components/css/Footer.css";
import { MdOutlineFacebook } from "react-icons/md";
import { AiFillTwitterCircle, AiFillSkype } from "react-icons/ai";
import { RiInstagramFill, RiMessengerFill } from "react-icons/ri";
const Footer = () => {
  return (
    <>
      <div className="mainDiv bgcolor">
        <div className="container-fluid text-white pt-5 pb-5">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="text-white iconsDiv">
                <h5>STAY CONNECTED</h5>
                <div className="d-flex align-items-center iconSize mt-3 mb-3">
                  <MdOutlineFacebook className="hovericon" />
                  <AiFillTwitterCircle className="hovericon" />
                  <RiInstagramFill className="hovericon" />
                  <RiMessengerFill className="hovericon" />
                  <AiFillSkype className="hovericon" />
                </div>
                <address>
                  Copyright&copy; : Huziafa Ali. All Right Reserved
                </address>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="text-white">
                <h5 className="stay">STAY CONNECTED</h5>
                <ul class="serivce-list clearfix mt-3">
                  <li>
                    <a href="#">Web Development</a>
                  </li>
                  <li>
                    <a href="#">Static Web Page</a>
                  </li>
                  <li>
                    <a href="#">Dynamic Web Page</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="text-white">
                <h5 className="stay">CUSTOMER SERVICES</h5>
                <ul class="serivce-list clearfix mt-3">
                  <li>
                    <a href="#">Web Development</a>
                  </li>
                  <li>
                    <a href="#">Static Web Page </a>
                  </li>
                  <li>
                    <a href="#">Dynamic Web Page Service</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="text-white">
                <h5 className="stay"> COLLABORATE WITH US</h5>
                <ul class="serivce-list clearfix mt-3">
                  <li>
                    <a href="#">Web Development Managemnet</a>
                  </li>
                  <li>
                    <a href="#">Static Web Page Privacy</a>
                  </li>
                  <li>
                    <a href="#">Dynamic Web Page</a>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
